import { render } from "./TelemetryBoard.vue?vue&type=template&id=1739622b"
import script from "./TelemetryBoard.vue?vue&type=script&lang=js"
export * from "./TelemetryBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__